import type {
  FunnelStageMetric,
  MetricValue,
  PercentMetricValue,
} from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';
import type { StageDisplayMode } from 'containers/user/critical-elements-monitoring/monitoring-constants';

export const getPrimaryMetric = (
  metric: Pick<FunnelStageMetric, 'volume' | 'rate' | 'proportion'>,
  displayMode: StageDisplayMode
): MetricValue | PercentMetricValue => {
  if (displayMode === 'rate') return metric.rate;
  if (displayMode === 'proportion') return metric.proportion;

  return metric.volume;
};
